import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faLocationDot } from "@fortawesome/free-solid-svg-icons";
// import axiosClient from "../../Utils/Axios/AxiosClient";
import trainingCardImg from "../../assets/images/training/trainingCardImg.png";
import { useSelector } from "react-redux";
// import toast from "react-hot-toast";
import styles from "./trainngcard.module.scss";
import { IoCheckmarkDone } from "react-icons/io5";

function TrainingCard({ program, setShowDetails, setFullprogramDetails }) {
  const userData = useSelector((state) => state.partner.user);
  console.log('Programssssss',program);
  
  const showMoreDetails = () => {
    setFullprogramDetails(program);
    setShowDetails(true)
  }

  return (
    <div className={styles.trainingCard} onClick={showMoreDetails}>
      <div className={styles.cardMedia}>
        <img src={program.media_url} alt="" />
      </div>

      <div className={styles.cardContent}>
        <h3>{program.program_name}</h3>
        <p className={styles.sponsorData}>{program.program_sponsor}</p>

        <p className={styles.shortDesc}>
          {
            program.program_desc
          }
        </p>

        <div className={styles.cardBtns}>
          {
            userData.partner.trainings.some(training => training.program_id === program.program_id) &&
            <button className={styles.enrolledBtn}>
              <IoCheckmarkDone /> Already Enrolled
            </button>
          }
          <button className={styles.readMoreBtn}>Read More</button>
        </div>
      </div>
    </div>
  );
}

export default TrainingCard;
